export class MoreDetails {
  /**
   * Getter utilityAccountNumber
   * @return {string}
   */
  public get utilityAccountNumber(): string {
    return this._utilityAccountNumber;
  }
  private _utilityAccountNumber: string;

  /**
   * Getter revenueTotal
   * @return {number}
   */
  public get revenueTotal(): number {
    return this._revenueTotal;
  }
  private _revenueTotal: number;

  /**
   * Getter volumeTotalFraction
   * @return {number}
   */
  public get volumeTotalFraction(): number {
    return this._volumeTotalFraction;
  }
  private _volumeTotalFraction: number;

  /**
   * Getter totalCommission
   * @return {number}
   */
  public get totalCommission(): number {
    return this._totalCommission;
  }
  private _totalCommission: number;

  /**
   * Getter totalConsumption
   * @return {number}
   */
  public get totalConsumption(): number {
    return this._totalConsumption;
  }
  private _totalConsumption: number;

  /**
   * Getter clientAdderTotal
   * @return {number}
   */
  public get clientAdderTotal(): number {
    return this._clientAddTotal;
  }
  private _clientAddTotal: number;

  /**
   * Getter energyCostTotal
   * @return {number}
   */
  public get energyCostTotal(): number {
    return this._energyCostTotal;
  }
  private _energyCostTotal: number;

  /**
   * Getter capacityCostTotal
   * @return {number}
   */
  public get capacityCostTotal(): number {
    return this._capacityCostTotal;
  }
  private _capacityCostTotal: number;

  /**
   * Getter nitsCostTotal
   * @return {number}
   */
  public get nitsCostTotal(): number {
    return this._nitsCostTotal;
  }

  /**
   * Getter otherIsoCostsTotal
   * @return {number}
   */
  public get otherIsoCostsTotal(): number {
    return this._otherIsoCostsTotal;
  }

  /**
   * Getter capacityCostPerUnit
   * @return {number}
   */
  public get capacityCostPerUnit(): number {
    return this._capacityCostTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter nitsCostPerUnit
   * @return {number}
   */
  public get nitsCostPerUnit(): number {
    return this._nitsCostTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter otherIsoCostsPerUnit
   * @return {number}
   */
  public get otherIsoCostsPerUnit(): number {
    return this._otherIsoCostsTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter tduCostPerUnit
   * @return {number}
   */
  public get tduCostPerUnit(): number {
    return this._tduCostTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter rpsCostPerUnit
   * @return {number}
   */
  public get rpsCostPerUnit(): number {
    return this._rpsCostTotal * 1000 / this._volumeTotal
  }

  /**
   * Getter brokerCommissionPerUnit
   * @return {number}
   */
  public get brokerCommissionPerUnit(): number {
    return this._brokerCommissionTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter otherCostsPerUnit
   * @return {number}
   */
  public get otherCostsPerUnit(): number {
    return this._otherCostsTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter energyCostPerUnit
   * @return {number}
   */
  public get energyCostPerUnit(): number {
    return this._energyCostTotal * 1000 / this._volumeTotal;
  }

  /**
   * Getter tduCostTotal
   * @return {number}
   */
  public get tduCostTotal(): number {
    return this._tduCostTotal;
  }

  /**
   * Getter rpsCostTotal
   * @return {number}
   */
  public get rpsCostTotal(): number {
    return this._rpsCostTotal;
  }

  /**
   * Getter brokerCommissionTotal
   * @return {number}
   */
  public get brokerCommissionTotal(): number {
    return this._brokerCommissionTotal;
  }

  /**
   * Getter volumeTotal
   * @return {number}
   */
  public get volumeTotal(): number {
    return this._volumeTotal;
  }
  private _volumeTotal: number;

  /**
   * Getter otherCostsTotal
   * @return {number}
   */
  public get otherCostsTotal(): number {
    return this._otherCostsTotal;
  }
  private _nitsCostTotal: number;
  private _otherIsoCostsTotal: number;
  private _tduCostTotal: number;
  private _rpsCostTotal: number;
  private _brokerCommissionTotal: number;
  private _otherCostsTotal: number;
  private _totalTotal: number;
  private _totalPerUnit: number;

  constructor(
    utilityAccountNumber: string,
    totalConsumption: number,
    volumeTotal: number,
    energyCostTotal: number,
    capacityCostTotal: number,
    nitsCostTotal: number,
    otherIsoCostsTotal: number,
    tduCostTotal: number,
    recComplianceCostTotal: number,
    brokerCommissionTotal: number,
    revenueTotal: number,
    commissionRaw: number,
    clientAdderTotal: number,
    nonIsoEnergyCostTotal: number,
  ) {
    this._utilityAccountNumber = utilityAccountNumber;
    this._totalConsumption = totalConsumption;
    this._volumeTotal = volumeTotal;
    this._energyCostTotal = energyCostTotal;
    this._capacityCostTotal = capacityCostTotal;
    this._nitsCostTotal = nitsCostTotal;
    this._otherIsoCostsTotal = otherIsoCostsTotal;
    this._tduCostTotal = tduCostTotal;
    this._rpsCostTotal = recComplianceCostTotal;
    this._brokerCommissionTotal = brokerCommissionTotal;
    this._revenueTotal = revenueTotal;
    this._totalCommission = (commissionRaw * volumeTotal) / 1000;
    //this._clientAddTotal = (clientAdderTotal * volumeTotal) / 1000;
    this._clientAddTotal = clientAdderTotal;
    this._otherCostsTotal = nonIsoEnergyCostTotal + this._totalCommission + this._clientAddTotal;
  }

  get totalTotal() {
    this._totalTotal =
      this._energyCostTotal +
      this._capacityCostTotal +
      this._nitsCostTotal +
      this._otherIsoCostsTotal +
      this._tduCostTotal +
      this._rpsCostTotal +
      this.otherCostsTotal;
    return this._totalTotal;
  }

  get totalPerUnit() {
    return this.totalTotal / this.volumeTotal * 1000;
  }
}
